module.exports = __webpack_public_path__ + "static/img/8.f257b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/img/8.png
// module id = cI62
// module chunks = 0